import { FONT_FAMILY } from "../../common/sharedFunctions";

const TableStyle = (settings) => {
  return {
    editable: {
      backgroundColor: '#FFFFFF',
      fontSize: "0.82rem",
      fontWeight: "600",
      fontFamily: FONT_FAMILY
    },
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
    padding: 'dense',
    headerStyle: {
      color: '#475569',
      position: "sticky",
      top: "0px",
      backgroundColor: '#F8FAFC',
      textAlign: "center",
      fontSize: "0.78rem",
      fontWeight: "700",
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      borderBottom: '2px solid #E2E8F0',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      padding: '14px 16px',
      fontFamily: FONT_FAMILY,
      whiteSpace: 'nowrap'
    },
    cellStyle: {
      borderBottom: '1px solid #F1F5F9',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      textAlign: "center",
      fontSize: "0.84rem",
      color: '#1E293B',
      padding: '12px 16px',
      fontFamily: FONT_FAMILY
    },
    rowStyle: (rowData, index) => ({
      backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#FAFAFA',
      transition: 'background-color 0.15s ease',
      '&:hover': {
        backgroundColor: '#F1F5F9 !important'
      }
    }),
    actionsColumnIndex: -1,
    searchFieldStyle: {
      fontFamily: FONT_FAMILY,
      fontSize: '0.88rem',
      borderRadius: '10px',
      padding: '6px 12px',
      border: '1px solid #E2E8F0',
      backgroundColor: '#F8FAFC',
      minWidth: '220px'
    }
  };
};

export default TableStyle;